import React, { useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useOktaAuth } from "@okta/okta-react";
import {
  resetResultVisualizationExpState,
  setResultVisualizationExpFilter,
} from "../../store/filterSlice";
import { RootState } from "../../store/store";
import {
  calculateTotalPages,
  forecastAnalysisHolidaysApi,
  forecastBackTestingDefaultGroupBy,
  forwardChartAPI,
  mapperForGroupByLableToKey,
  resultVisualisationChartExperimentaionApi,
  resultVisualisationChartExperimentaionForwardForecastTableApi,
  resultVisualisationChartExperimentaionTableApi,
  resultVisualisationFilterExperimentaionApi,
  resultVisualizationAverageExperimentaitonApi,
  resultVisulizationExperimentDefaultGroupBy,
} from "../../api/forecastPageApi";
import {
  resetExperId,
  resetFFChartState,
  resetResultVisulizationExperimentBackTestingTableDataSetter,
  resetResultVisulizationExperimentForwardForecastDataSetter,
  resultVisulizationExperimentBackTestingTableDataSetter,
  resultVisulizationExperimentForwardForecastDataSetter,
  setChartData,
  setExperimentationData,
  setExperimentId,
  setHolidaysData,
  setLoader,
  setProductionData,
  setPromotionImpactData,
  updateExperinemtBackTestingTotalPages,
  updateExperinemtForewardForecastTotalPages,
} from "../../store/resultVisualizationExperimentation";
import { PAGE_LIMIT } from "../../utils/constant";
import FilterResetModal from "../../baseComponent/Filter/FilterResetModal";
import FilterButtons from "../../baseComponent/Filter/FilterButtons";
import FilterDropdownExperiment from "../../baseComponent/Filter/FilterDropdownExperiment";
import { DynamicMappings } from "../../utils/dynamicMappings";
import ComparisonResultExperimentation from "../../pages/ResultVisualization/ComparisonResultExperimentation";
import ResultVisulizationExperimentBacktestingResults from "../BackTesting/ResultVisulizationBackTesting/ResultVisulizationExperimentBacktestingResults";

const ResultVisualizationExperimentalFilter: React.FC = () => {
  const [open, setOpen] = React.useState(false);
  const [tablePayload, setTablePayload] = useState(null);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { authState } = useOktaAuth();
  const dispatch = useDispatch();
  const dataShowKeyValueMappings = DynamicMappings();

  const userData = useSelector((state: RootState) => state.user);

  const filter = useSelector(
    (state: RootState) => state.resultVisualizationExpFilter
  );

  const resultVisulizationExperimentBackTestingPagination = useSelector(
    (state: RootState) =>
      state.resultVisulizationExperimentBackTestingPagination
  );

  const resultVisulizationForewardForecastPagination = useSelector(
    (state: RootState) => state.resultVisulizationForewardForecastPagination
  );

  const measurementToggleActiveComparisonExp = useSelector(
    (state: RootState) =>
      state.resultVisualizationData.measurementToggleActiveComparisonExp
  );

  const lagDropdownData = useSelector(
    (state: RootState) => state.lagDropdownData
  );

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    resetFilter();
  }, []);

  const hoildayPayload = {
    shortTermMidTermCode: filter?.term.toString(),
    sector: userData?.currentSector?.sector,
    market: userData?.currentSector?.market,
    isFFHolidays: true,
    brandName: filter?.brand,
    subBrandName: filter?.subBrand,
    keyAccount: filter?.keyAccount,
    materialGlobalTradeItemNumberDescription: filter?.planningItem,
    productLineName: filter?.productLine,
    productGroupName: filter?.productGroup,
    packageSizeName: filter?.size,
    productCategoryName: filter?.category,
    eachUPC: filter?.eachUPC,
    portfolioGroupName: filter?.mg4PortfolioGroup,
    packageTypeName: filter?.container,
    salesRegionName: filter?.salesRegion,
    salesZoneName: filter?.zone,
    salesCountryCode: filter?.salesCountry,
    forecastModuleCode: filter?.ac1ac2,
    forecastEngineSegmentationId: filter?.segment,
    packageName: filter?.count,
    customerGlobalName: filter?.global,
    customerSectorNumber: filter?.customerSector,
    customerRegionName: filter?.customerRegion,
    customerGroupName: filter?.customerGroup,
    customerBusinessUnitName: filter?.businessUnit,
    customerMarketUnitName: filter?.marketUnit,
    ibpDemandGroup: filter?.ibpDemandGroup,
    customerTradeSegmentDescription: filter?.cg1TrageSegment,
    salesSectorName: filter?.salesSector,
    salesOrganizationCode: filter?.businessOrg,
    salesDivisionName: filter?.division,
    forecastEngineClusterId: filter?.clusters,
    pageNumber: 1,
    pageSize: PAGE_LIMIT,
    // LATAM key
    flavorName: filter?.flavourNames,
    customerChannelName: filter?.channels,
    customerDemandGroup: filter?.demandGroups,
    customerSubChannelName: filter?.subChannels,
    customerRegionalCluster: filter?.regionalClusters,
    locationGlobalName: filter?.globalCode,
    locationSectorName: filter?.locationSector,
    locationCountryName: filter?.locationCountry,
    planningLocationId: filter?.planningLocationId,
    locationRegionName: filter?.regionCode,
    // PFNA key
    alternateIBPDemandGroup: filter?.alternateIBPDemandGroup,
  };

  const payloadForLag = {
    shortTermMidTermCode: filter?.term.toString(),
    experimentId: filter?.experimentId[0] === "" ? [] : filter?.experimentId,
    sector: userData?.currentSector?.sector,
    market: userData?.currentSector?.market,
  };

  const backtestingPayloadFilters = {
    shortTermMidTermCode: filter?.term.toString(),
    // snapshotDate:
    //   filter?.term.toString() === "ST"
    //     ? filter?.shortSnapshotDate
    //     : filter?.midSnapshotDate,
    brandName: filter?.brand,
    subBrandName: filter?.subBrand,
    productLineName: filter?.productLine,
    productGroupName: filter?.productGroup,
    packageSizeName: filter?.size,
    keyAccount: filter?.keyAccount,
    materialGlobalTradeItemNumberDescription: filter?.planningItem,
    productCategoryName: filter?.category,
    eachUPC: filter?.eachUPC,
    portfolioGroupName: filter?.mg4PortfolioGroup,
    packageName: filter?.count,
    packTypeName: filter.ppg,
    experimentId: filter?.experimentId[0] === "" ? [] : filter?.experimentId,
    customerGlobalName: filter?.global,
    customerSectorNumber: filter?.customerSector,
    customerRegionName: filter?.customerRegion,
    customerGroupName: filter?.customerGroup,
    customerBusinessUnitName: filter?.businessUnit,
    customerMarketUnitName: filter?.marketUnit,
    ibpDemandGroup: filter?.ibpDemandGroup,
    customerTradeSegmentDescription: filter?.cg1TrageSegment,
    salesSectorName: filter?.salesSector,
    salesOrganizationCode: filter?.businessOrg,
    salesCountryCode: filter?.salesCountry,
    salesDivisionName: filter?.division,
    salesRegionName: filter?.salesRegion,
    salesZoneName: filter?.zone,
    forecastModuleCode: filter?.ac1ac2,
    packageTypeName: filter?.container,
    forecastEngineSegmentationId: filter?.segment,
    forecastEngineClusterId: filter?.clusters,
    pageNumber: 1,
    sector: userData?.currentSector?.sector,
    market: userData?.currentSector?.market,
    pageSize: PAGE_LIMIT,
    // LATAM Key
    flavorName: filter?.flavourNames,
    customerChannelName: filter?.channels,
    customerDemandGroup: filter?.demandGroups,
    customerSubChannelName: filter?.subChannels,
    customerRegionalCluster: filter?.regionalClusters,
    locationGlobalName: filter?.globalCode,
    locationSectorName: filter?.locationSector,
    locationCountryName: filter?.locationCountry,
    planningLocationId: filter?.planningLocationId,
    locationRegionName: filter?.regionCode,
    // PFNA key
    alternateIBPDemandGroup: filter?.alternateIBPDemandGroup,
  };

  const payload: any = {
    ...backtestingPayloadFilters,
  };

  const measurementPayload = {
    ...payload,
    rank: filter?.rankComparision.map(Number),
  };
  // measurement toggle active Table Experience value
  const measurementToggleActiveTableExp = useSelector(
    (state: RootState) =>
      state.resultVisualizationExperimentationData
        .measurementToggleActiveTableExp
  );

  if (
    userData?.sections?.predefinedRunsExperimentation?.table?.lagDropdown &&
    filter?.term?.toString() === "ST" &&
    lagDropdownData.experimentLagForSt !== null
  ) {
    payload["forecastLagNumber"] = Number(lagDropdownData.experimentLagForSt);
  }
  if (
    userData?.sections?.predefinedRunsExperimentation?.table?.lagDropdown &&
    filter?.term?.toString() === "MT" &&
    lagDropdownData.experimentLagForMt !== null
  ) {
    payload["forecastLagNumber"] = Number(lagDropdownData.experimentLagForMt);
  }

  if (userData?.currentSector?.sector === "LATAM") {
    // flag added for handling measurement requirement
    payload["isMeasurement"] =
      measurementToggleActiveComparisonExp === "measurementLevel"
        ? true
        : false;
  }

  const forwardChartPayload = {
    ...backtestingPayloadFilters,
    rank: filter?.rankForward?.map(Number),
    experimentId: [],
  };

  const forwardTablePayload = {
    ...backtestingPayloadFilters,
    experimentId: [],
  };

  const backTestingChartPayload = {
    ...payload,
    rank: filter?.rankBackTestingChart.map(Number),
  };

  useEffect(() => {
    if (
      resultVisulizationExperimentBackTestingPagination?.totalPages > 1 &&
      resultVisulizationExperimentBackTestingPagination?.isDataShownClicked ===
        false
    ) {
      makeExperimentBackTesingApiCall(backtestingPayloadFilters, authState);
    }
  }, [resultVisulizationExperimentBackTestingPagination?.pageNumber]);

  useEffect(() => {
    if (resultVisulizationForewardForecastPagination?.totalPages > 1) {
      makeExperimentForewardForecastApiCall(forwardTablePayload, authState);
    }
  }, [resultVisulizationForewardForecastPagination?.pageNumber]);

  const handleApplyFilters = async () => {
    dispatch(setLoader(true));
    resultVisualisationFilterExperimentaionApi(payloadForLag, authState).then(
      (data) => dispatch(setExperimentId(data))
    );
    resultVisualizationAverageExperimentaitonApi(
      { ...payload, rank: filter?.rankComparision.map(Number) },
      authState
    ).then((data) => {
      dispatch(setExperimentationData(data?.experimentData));
      dispatch(setProductionData(data?.productionData));
    });
    forwardChartAPI(forwardChartPayload, authState).then((data) =>
      dispatch(setPromotionImpactData(data?.chartData))
    );
    forecastAnalysisHolidaysApi(hoildayPayload, authState).then((data) =>
      dispatch(setHolidaysData(data?.holidayIndicators))
    );
    resultVisualisationChartExperimentaionApi(
      backTestingChartPayload,
      authState
    ).then((data) => dispatch(setChartData(data?.chartData)));
    makeExperimentBackTesingApiCall(backtestingPayloadFilters, authState);
    makeExperimentForewardForecastApiCall(forwardTablePayload, authState);
  };
  const resetFilter = () => {
    dispatch(resetExperId());
    dispatch(resetResultVisualizationExpState({}));
    dispatch(setLoader(false));
    dispatch(resetResultVisulizationExperimentBackTestingTableDataSetter());
    dispatch(resetResultVisulizationExperimentForwardForecastDataSetter());
    dispatch(resetFFChartState());

    // Reset the term to 'ST' in all relevant filters
    dispatch(setResultVisualizationExpFilter({ key: "term", value: ["ST"] }));
    handleClose();
    if (userData?.currentSector?.sector === "PFNA") {
      dispatch(
        setResultVisualizationExpFilter({
          key: "ac1ac2",
          value: ["AC1"],
        })
      );
    }
  };

  const makeExperimentBackTesingApiCall = (
    resultVisulizationExperiementApiRequestBodyTable: any,
    authState: any
  ) => {
    dispatch(
      resultVisulizationExperimentBackTestingTableDataSetter({
        isTableDataLoading: true,
        backTestingTableData: [],
        tableHeader: [],
      })
    );

    const groupByPFNAData =
      userData?.currentSector?.sector === "PFNA" &&
      filter?.ac1ac2?.[0] !== undefined &&
      filter?.ac1ac2?.[0] === "AC1"
        ? userData?.sections?.predefinedRunsExperimentation?.table?.defaultDataShown?.backTesting.filter(
            (item) => item !== "Planning Item" && item !== "UPC"
          )
        : userData?.sections?.predefinedRunsExperimentation?.table
            ?.defaultDataShown?.backTesting;

    const backTestingGroupByOptions = mapperForGroupByLableToKey(
      groupByPFNAData,
      dataShowKeyValueMappings
    );

    const resultVisulizationTestingApiRequestBody = {
      ...resultVisulizationExperiementApiRequestBodyTable,
      pageNumber: resultVisulizationExperimentBackTestingPagination?.pageNumber,
      pageSize: resultVisulizationExperimentBackTestingPagination?.pageLimit,
      groupBy: backTestingGroupByOptions?.selectedGroupByOptions,
      rank: filter?.rankBackTestingChart.map(Number),
    };

    if (
      userData?.sections?.predefinedRunsExperimentation?.table?.lagDropdown &&
      filter?.term?.toString() === "ST" &&
      lagDropdownData.experimentLagForSt !== null
    ) {
      resultVisulizationTestingApiRequestBody["forecastLagNumber"] = Number(
        lagDropdownData.experimentLagForSt
      );
    }
    if (
      userData?.sections?.predefinedRunsExperimentation?.table?.lagDropdown &&
      filter?.term?.toString() === "MT" &&
      lagDropdownData.experimentLagForMt !== null
    ) {
      resultVisulizationTestingApiRequestBody["forecastLagNumber"] = Number(
        lagDropdownData.experimentLagForMt
      );
    }

    if (userData?.currentSector?.sector === "LATAM") {
      // flag added for handling measurement requirement
      resultVisulizationTestingApiRequestBody["isMeasurement"] =
        measurementToggleActiveTableExp === "measurementLevel" ? true : false;
    }

    setTablePayload(resultVisulizationTestingApiRequestBody);

    resultVisualisationChartExperimentaionTableApi(
      resultVisulizationTestingApiRequestBody,
      authState
    )
      .then((response) => {
        dispatch(setLoader(true));
        const totalBackTestingPages = calculateTotalPages(
          PAGE_LIMIT,
          response?.totalCount
        );
        dispatch(
          updateExperinemtBackTestingTotalPages({
            totalPages: totalBackTestingPages,
            pageLimit:
              resultVisulizationExperimentBackTestingPagination.pageLimit,
            pageNumber:
              resultVisulizationExperimentBackTestingPagination.pageNumber,
            isDataShownClicked:
              resultVisulizationExperimentBackTestingPagination.isDataShownClicked,
          })
        );
        dispatch(
          resultVisulizationExperimentBackTestingTableDataSetter({
            tableHeader: response?.dynamicTableHeader,
            backTestingTableData: response?.dfuBasedGroupedData,
            isTableDataLoading: false,
          })
        );
        dispatch(setLoader(false));
      })
      .catch((error) => {
        console.log("resultVisulizationTestingTableApi error", error);
      });
  };

  const makeExperimentForewardForecastApiCall = (
    resultVisulizationExperiementApiRequestBodyTable: any,
    authState: any
  ) => {
    dispatch(
      resultVisulizationExperimentForwardForecastDataSetter({
        isTableDataLoading: true,
        backTestingTableData: [],
        tableHeader: [],
      })
    );

    const groupByPFNAData =
      userData?.currentSector?.sector === "PFNA" &&
      filter?.ac1ac2?.[0] !== undefined &&
      filter?.ac1ac2?.[0] === "AC1"
        ? userData?.sections?.predefinedRunsExperimentation?.table?.defaultDataShown?.forewardForecast.filter(
            (item) => item !== "Planning Item" && item !== "UPC"
          )
        : userData?.sections?.predefinedRunsExperimentation?.table
            ?.defaultDataShown?.forewardForecast;

    const forewordForcastGroupByOptions = mapperForGroupByLableToKey(
      groupByPFNAData,
      dataShowKeyValueMappings
    );

    const resultVisulizationTestingApiRequestBody = {
      ...resultVisulizationExperiementApiRequestBodyTable,
      pageNumber: resultVisulizationForewardForecastPagination?.pageNumber,
      pageSize: resultVisulizationForewardForecastPagination?.pageLimit,
      groupBy: forewordForcastGroupByOptions?.selectedGroupByOptions,
    };

    resultVisualisationChartExperimentaionForwardForecastTableApi(
      {
        ...resultVisulizationTestingApiRequestBody,
        rank: filter?.rankForward.map(Number),
      },
      authState
    )
      .then((response) => {
        dispatch(setLoader(true));
        const totalForewordforcastPages = calculateTotalPages(
          PAGE_LIMIT,
          response?.totalCount
        );
        dispatch(
          updateExperinemtForewardForecastTotalPages({
            totalPages: totalForewordforcastPages,
            pageLimit: resultVisulizationForewardForecastPagination.pageLimit,
            pageNumber: resultVisulizationForewardForecastPagination.pageNumber,
            isDataShownClicked:
              resultVisulizationForewardForecastPagination.isDataShownClicked,
          })
        );
        dispatch(
          resultVisulizationExperimentForwardForecastDataSetter({
            tableHeader: response?.dynamicTableHeader,
            backTestingTableData: response?.dfuBasedGroupedData,
            isTableDataLoading: false,
          })
        );
        dispatch(setLoader(false));
      })
      .catch((error) => {
        console.log("resultVisulizationTestingTableApi error", error);
      });
  };

  return (
    <>
      <div className="p-5 bg-secondary-bg mt-4 rounded">
        {open && (
          <FilterResetModal
            open={open}
            resetFilter={resetFilter}
            handleClose={handleClose}
          />
        )}
        <FilterButtons
          handleOpen={handleOpen}
          applyFilters={handleApplyFilters}
        />
        <FilterDropdownExperiment />
      </div>
      <ComparisonResultExperimentation
        measurementPayload={measurementPayload}
      />
      {tablePayload !== null && (
        <div className="mt-2">
          <ResultVisulizationExperimentBacktestingResults
            widthColumn="12%"
            isResultVisulizationPage={false}
            isExperimentationPage={true}
            measurementPayload={tablePayload}
            isPredefined={false}
          />
        </div>
      )}
    </>
  );
};

export default ResultVisualizationExperimentalFilter;
